const base_url = process.env.VUE_APP_BASE_URL
import router from '@/router/index';
import { AppConstants } from "@/webComponents/wcOrderDetail/constants.ts";
import Axios from "axios";

const http = Axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
        "Content-type": "application/json",
    }
});

const noTokenRequest =  Axios.create({
    baseURL: base_url,
    headers: {
        "Content-type": "application/json"
    }
});

http.interceptors.request.use((request) => {
    const token = localStorage.getItem('access_token')
    if (token) {
        request.headers.Authorization = `Bearer ${token}`
    }
    return request
})

http.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status) {
        localStorage.setItem('access_token', '');
        if (window.location.pathname !== "/login") {
            window.location.href = "/login";
        }
    } else if (403 === error.response.status) {
        if ( AppConstants.isOrderDetailWebComponent === false) {
            router.push({ name: 'Unauthorized' })
        }
    } else {
        return Promise.reject(error);
    }
});

export { http, noTokenRequest };

